import { render, staticRenderFns } from "./UserBaseInfo.vue?vue&type=template&id=7f648ebe&scoped=true&"
import script from "./UserBaseInfo.vue?vue&type=script&lang=ts&"
export * from "./UserBaseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UserBaseInfo.vue?vue&type=style&index=0&id=7f648ebe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f648ebe",
  null
  
)

export default component.exports